export default "__VITE_ASSET__BuT6LaDJ__"